import { HmacMD5 } from 'crypto-js';
import Base64 from 'crypto-js/enc-base64';
import Latin1 from 'crypto-js/enc-latin1';
import md5 from 'md5';
// import qs from 'qs';
import { AxiosResponse } from 'axios';
import * as des from './des';
import NetworkError from './error';
import { isNumber, isString, startsWith, toNumber, toString } from 'lodash-es';
import { NetworkTypeEnum } from '@star/constants';

// import NetworkError from './error'
import { start, storeToRefs, useAppStore, useTenantStore, useUserStore } from '../../index';
import { getBetPlatform, isMobile, uuid } from '@star/utils';
import { langToNum } from '@star/languages';

// 请求到的数据返回
export type NetworkResponse<T> = {
  type: NetworkTypeEnum;
  data: T;
};

// 格式化要发送的数据
export const formatSendData = (data: any, type: number = 0) => {
  // url code
  if (type === 0) {
    const arr: any[] = [];
    for (const k in data) {
      const v = data[k];
      if (v instanceof Array) {
        for (const subK in v) {
          arr.push(`${k}[]=${v[subK]}`);
        }
      } else {
        arr.push(`${k}=${data[k]}`);
      }
    }
    return arr.join('&');
  } else if (type === 2) {
    return data.join('/');
  }
  // json
  return JSON.stringify(data);
};

export const getP = p => {
  return HmacMD5(p, '7NEkojNzfkk=').toString();
};

export const enD = (rk, str) => {
  const enc = des.des(rk, str, 1, 0, null, 1);
  return Base64.stringify(Latin1.parse(enc));
};

export const dnD = (rk, str) => {
  const s = Latin1.stringify(Base64.parse(str));
  const d = des.des(rk, s, 0, 0, null, 1);
  return d;
};

export const enP = (rk, vk, t) => {
  const enc = des.des(vk, rk + t, 1, 0, null, 1);
  return Base64.stringify(Latin1.parse(enc));
};

export const dnP = (vk, str) => {
  const s = Latin1.stringify(Base64.parse(str));
  const p = des.des(vk, s, 0, 0, null, 1);
  return p;
};

export const enC = (rk, vk, m) => {
  const enc = HmacMD5(m + rk, vk);
  return Base64.stringify(enc);
};

export const getRequestKey = (cmdId: number, data: any) => {
  return `${cmdId}&${data ? md5(data) : ''}`;
};

// 加工请求数据
export const transformRequest = (config: any) => {
  const { headerType = 2, paramType = 0, cmdId, tid, ...reset } = config.headers;
  const headers: Record<string, any> = {};
  const { tenantInfo } = storeToRefs(useTenantStore());
  const { userInfo } = storeToRefs(useUserStore());
  const { language } = storeToRefs(useAppStore());
  const t = new Date().getTime();
  const rk = md5(toString(Math.random() + t)).substring(0, 8);
  const vk = start.vk;
  const pwds = enP(rk, vk, t);
  const sendStr = enD(rk, formatSendData(config.data, toNumber(paramType)));
  const sendDateStr = enD(rk, t.toString());
  const checkOr = enC(rk, vk, sendDateStr);

  headers.cmdId = cmdId;
  headers.aseqId = start.aseqId;
  headers.nc = start.nc;
  headers.tid = tid ?? tenantInfo.value?.tid ?? '';
  // 试玩游戏cust_id=0 header需要保持一致
  headers.custId = (config.data?.cust_id === 0 ? '0' : '') || userInfo?.value?.cust_id || '';
  headers.reqId = uuid(32, 16);
  headers.isMobileOpen = isMobile() ? '1' : '0';
  headers.languageNum = langToNum(language.value);
  headers.project = import.meta.env.VITE_API_PROJECT;
  headers.platform = getBetPlatform(); // 哪端
  headers.checkOr = checkOr;
  headers.pwds = pwds;
  headers.datetime = t;
  headers.tbc = md5(t + 'fT6phq0wkOPRlAoyToidAnkogUV7tBBD');
  headers.reqKey = getRequestKey(cmdId, config.data); // 每一个接口请求的唯一key，前端用

  if (toNumber(headerType) === 1) {
    const grantType = 'password';
    const scope = 'read write';
    const signature = `react_clientgrant_type=${grantType}scope=${scope}cmd_id=${cmdId}react`;
    headers.signature = md5(signature);
  } else if (toNumber(headerType) === 2) {
    const authorization = `Bearer ${userInfo?.value?.access_token || ''}`;
    const signature = `react_clientauthorization=${authorization}cmd_id=${cmdId}react`;
    headers.authorization = authorization;
    headers.signature = md5(signature);
  } else if (toNumber(headerType) === 3) {
    const grantType = 'refresh_token';
    const scope = '';
    const signature = `react_clientgrant_type=${grantType}scope=${scope}cmd_id=${cmdId}react`;
    headers.signature = md5(signature);
  }

  // console.log(headers, cmdId, '<------ request headers');
  localStorage.getItem('SHOW_DATA') &&
    console.warn(cmdId, '最终请求参数', formatSendData(config.data, toNumber(paramType))); // 查看最终请求参数
  console.log(cmdId, 'request data --->', config.data);
  return {
    headers: { ...reset, ...headers },
    data: sendStr,
  };
};

// 解释响应数据
export const parseResponse = (response: AxiosResponse): Promise<NetworkResponse<any>> => {
  try {
    const { headers, data } = response;
    const reqHeaders = response.config?.headers || {};
    // if (reqHeaders.cmdId == 310122) {
    //   console.log(data, reqHeaders.cmdId, '<<<<<<<<<<<<<<<<<<<<<<<<<< parseResponse data');
    // }
    if (isString(data) && data.length > 0 && !startsWith(data, '<html>')) {
      const drk = dnP(start.vk, headers.pwds ?? '').substring(0, 8);
      const dm = dnD(drk, data);
      const dc = enC(drk, start.vk, enD(drk, toString(headers.datetime)));
      // if (reqHeaders.cmdId == 310122) {
      //   console.log(dm, JSON.parse(dm), reqHeaders.cmdId);
      // }
      localStorage.getItem('SHOW_DATA') && console.warn(reqHeaders.cmdId, JSON.parse(dm)); // 查看请求返回的数据
      if (!dm) {
        throw new NetworkError({
          key: '',
          tag: 'Network error 1',
          info: '数据为空',
          origin: '',
          cmd: reqHeaders.cmdId,
        });
      }
      if (dc !== headers.checkor) {
        throw new NetworkError({
          key: '',
          tag: 'Network error 2',
          info: '返回数据异常',
          origin: '',
          cmd: reqHeaders.cmdId,
        });
      }

      const resData: any = JSON.parse(dm);
      console.log(
        JSON.parse(JSON.stringify(resData)),
        reqHeaders.cmdId,
        '<<<<<<<<<<<<<<<<<<<<<<<<<< parseResponse resData'
      );
      if (resData) {
        if (resData.exLevel) {
          // 接口请求的错误处理
          let err: any;
          // 预存奖励领取的时候  返回'0'提示
          if ([724209].includes(+reqHeaders.cmdId)) {
            throw {
              key: '',
              tag: 'Network error 3',
              info: resData.exMessage,
              origin: resData,
              cmd: reqHeaders.cmdId,
              code: resData.exCode,
            };
          } else {
            err = new NetworkError({
              key: '',
              tag: 'Network error 3',
              info: resData.exMessage,
              origin: resData,
              cmd: reqHeaders.cmdId,
              code: resData.exCode,
            });
          }
          // 版本号不对，强制更新
          if (err.code === 1108) {
            err.update = true;
          } else if ([1200, 1201, 1109, 1112, 1202, 1007].includes(+err.code)) {
            // 1200 refresh_token错误
            // 1201 access_token错误
            // 1112 IP限制
            err.logout = true; // 退出登录
            err.tag = 'Network error 4';
            err.logoutMessage = '返回异常';
          }
          throw err;
        } else if (resData.error) {
          throw new NetworkError({
            key: '',
            tag: 'Network error 5',
            info: resData.error_description,
            origin: resData,
            cmd: reqHeaders.cmdId,
            code: resData.exCode,
          });
        } else if (resData.response_code === '0') {
          // 回收第三方金额 没有的的时候 也是返回'0'
          // 预存奖励领取的时候  返回'0'提示
          if ([3911381, 724209].includes(+reqHeaders.cmdId)) {
            resData.response_code = '1';
          } else {
            throw new NetworkError({
              key: '',
              tag: 'Network error 8',
              info: resData.msg || '操作失败',
              origin: resData,
              cmd: reqHeaders.cmdId,
              code: resData.exCode,
            });
          }
        }
      } else {
        if (!isNumber(toNumber(resData))) {
          throw new NetworkError({
            key: '',
            tag: 'Network error 1',
            info: '数据为空',
            origin: '',
            cmd: reqHeaders.cmdId,
          });
        }
      }
      return Promise.resolve({ type: NetworkTypeEnum.SUCCESS, data: resData });
    } else {
      localStorage.getItem('SHOW_DATA') && console.warn(reqHeaders.cmdId, data); // 查看请求返回的原始数据
      throw new NetworkError({
        key: '',
        tag: 'Network error 7',
        info: '请求没有返回任何数据',
        // origin: context || response.toString(),
        cmd: reqHeaders.cmdId,
        code: -1,
      });
    }
  } catch (e) {
    // // 404等错误处理
    // if (typeof context === 'object') {
    //   errStr = JSON.stringify(context);
    // } else {
    //   const arr = context.match(/title[\s\S]*?title/g);
    //   if (arr && arr.length !== 0) {
    //     errStr = arr[0].replace(/title>/g, '').replace(/<\/title/g, '');
    //   }
    // }
    // let logout = false;
    // if (errStr.indexOf('invalid_token') !== -1) {
    //   logout = true;
    // }
    // // 类似这种错误的时候 跳到登录页 "error":"access_denied" "error":"unauthorized"
    // if (errStr.indexOf('access_denied') !== -1 || errStr.indexOf('unauthorized') !== -1) {
    //   logout = true;
    // }
    // err = new NetworkError({
    //   key: key,
    //   tag: 'Network error 6',
    //   info: errStr,
    //   origin: context,
    //   cmd: reqHeaders.cmdId,
    //   code: -1,
    //   logout: logout,
    // });
    return Promise.reject({ type: NetworkTypeEnum.ERROR, data: e });
  }
};
